<template>
    <div class="get-coupons-warp">
        <img src="../assets/img/couponsBg2.jpg" />
        <div class="coupons-get-btn" @click="getCoupon"></div>
        <Loading v-if="isLoading"/>
    </div>
</template>
<script>
import { receiveCoupons, showCouponsFlag } from '../api/index.js'
import Loading from '../components/loaddingCom'
import { Dialog } from 'vant';
export default {
    components: { Loading },
    data() {
        return {
            showGetCoupons: false,
            isLoading: false
        }
    },
    mounted() {
        this.showCouponsFlag()
    },
    methods: {
        showCouponsFlag() {
            showCouponsFlag().then(res => {
                console.log('showCouponsFlag', res)
                if(res.data == 1) {
                    this.showGetCoupons = true
                }
            })
        },
        getCoupon () {
            if (!showCouponsFlag) {
                Dialog.confirm({
                    title: '领取失败',
                    message: '领券活动已结束，详情请咨询管理员！',
                    showCancelButton: false
                })
                .then(() => {
                    this.$router.replace({path: '/indexPageNew'})
                })
                return
            }
            this.isLoading = true
            receiveCoupons().then(res => {
                this.isLoading = false
                if(res.message == 'success') {
                    Dialog.confirm({
                        title: '领取成功',
                        message: '优惠券领取成功，去使用吧！',
                        showCancelButton: false
                    })
                    .then(() => {
                        this.$router.replace({path: '/userCenter'})
                    })
                }
            }).catch((error) => {
                console.log('error', error)
                this.isLoading = false
                Dialog.confirm({
                    title: '领取失败',
                    message: error.response.data.message,
                    showCancelButton: false
                })
                .then(() => {
                    if(error.response.data.message == '请先完善生日信息') {
                        this.$router.replace({path: '/loginOut'})
                    } else {
                        this.$router.replace({path: '/userCenter'})
                    }
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.get-coupons-warp {
    width: 100vw;
    position: relative;
    img {
        width: 100%;
    }
    .coupons-get-btn {
        width: 225px;
        height: 60px;
        position: absolute;
        top: 330px;
        left: 75px;
    }
}
</style>

